module.exports = __webpack_public_path__ + "img/video.e3c5ff43.png";